import { Order, ProductFilters, ReservationFilters, ServiceOrderOrdering } from '@mews-commander/data-access';
import { isDefined } from '@mews/std';
import { TableFilters, TableState } from '@optimus-web/core';
import { FilterValueKey, ProductCheckListFilterValues } from '../components/panels/ProductCheckListFilterFields/types';
import { ProductCheckListTableColumn } from '../containers/ProductCheckListTable/types';
import { productCheckListColumnToServiceOrderOrdering } from '../containers/ProductCheckListTable/utils/convertTypes';

export const getProductFiltersQueryParam = (filters: ProductCheckListFilterValues): ProductFilters | undefined => {
    const displayReservationsWithoutProducts = filters[FilterValueKey.displayReservationsWithoutProducts];

    return displayReservationsWithoutProducts
        ? undefined
        : {
              productIds: getProductIdsFromFilters(filters),
          };
};

export const getProductIdsFromFilters = (filters: ProductCheckListFilterValues): string[] =>
    Object.values(filters[FilterValueKey.productIds]).filter(isDefined).flat();

export const getReservationFiltersQueryParam = (filters: ProductCheckListFilterValues): ReservationFilters => ({
    reservationStatus: filters[FilterValueKey.reservationStatus],
});

export const getOrderingQueryParams = <T>(
    tableState: TableState<T, TableFilters<T>>
): { order: Order; orderBy: ServiceOrderOrdering } => {
    const [columnKey, columnValue] = (Object.entries(tableState.sort ?? {})[0] || []) as [string, { order?: Order }];
    return {
        order: (columnValue && 'order' in columnValue && columnValue.order) || Order.Ascending,
        orderBy: columnKey
            ? productCheckListColumnToServiceOrderOrdering(columnKey as ProductCheckListTableColumn)
            : ServiceOrderOrdering.ResourceNumber,
    };
};
